import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';

import { NotificationService, INotification, NotificationType } from '../../se-ui-utilities/notification.service';
import { RouterStackService } from '../../se-ui-utilities/router-stack.service';

@Component({
    selector: 'se-notifications',
    templateUrl: './se-notifications.component.html',
    styleUrls: ['./se-notifications.component.css']
})
export class SeNotificationsComponent implements OnInit, OnDestroy {

    // events

    @Output()
    visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    // data members

    @Input()
    visible: boolean;

    private _notifications: Array<INotification> = new Array<INotification>();
    get notifications() {
        return this._notifications;
    }
    get filteredNotifications() {
        return this._notifications.filter(notification => {

            return (this.errorActive && notification.type == NotificationType.error) ||
                (this.warningActive && notification.type == NotificationType.warning) ||
                (this.infoActive && notification.type == NotificationType.information);
        });
    }

    @Input()
    lastNotification: INotification;

    errorActive = false;
    warningActive = false;
    infoActive = false;
    lastActive = true;

    private _notificationSubscriber = null;

    // constructor

    constructor(
        private notificationService: NotificationService,
        private routerStackService: RouterStackService) {
    }

    // public functions

    ngOnInit() {

        this._notificationSubscriber = this.notificationService
            .notification
            .subscribe(notification => {
                // Sollevo solo se non si tratta di una pagina VNext pechè in quel caso ho la gestione delle notifiche in toolbar
                if (!this.routerStackService.url.startsWith('/new/vnext')) {
                    this.lastNotification = notification;
                    this.notifications.splice(0, 0, notification);
                    this.visible = true;
                }
            });
    }

    ngOnDestroy() {

        this._notificationSubscriber.unsubscribe();
    }

    errorCount() {
        return this.notifications.filter(notification => notification.type == NotificationType.error).length;
    }

    warningCount() {
        return this.notifications.filter(notification => notification.type == NotificationType.warning).length;
    }

    infoCount() {
        return this.notifications.filter(notification => notification.type == NotificationType.information).length;
    }

    onErrorClick() {
        this.lastActive = false;
        this.errorActive = !this.errorActive;
    }

    onWarningClick() {
        this.lastActive = false;
        this.warningActive = !this.warningActive;
    }

    onInfoClick() {
        this.lastActive = false;
        this.infoActive = !this.infoActive;
    }

    onLastClick() {
        this.errorActive = false;
        this.warningActive = false;
        this.infoActive = false;
        this.lastActive = !this.lastActive;
    }

    onDeleteClick() {
        this.notifications.splice(0, this.notifications.length);
        this.lastNotification = null;
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    onCloseClick() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }
}
